import { isValidEmailAddress } from '../functions';
//import Swal from 'sweetalert2';

$(document).ready(function() {
    const testimonials = {
        isLoading: false,
        init() {
            $(document).on('click', '#testimonial-save-btn', this, this.send);
        },
        send(event) {
            event.preventDefault();
            //event.stopImmediatePropagation();
            const _this = event.data;
			let element = this;

            if (_this.isLoading) {
                return false;
            }

			$('#testimonials-form-modal').find('.form-control').removeClass('is-invalid');
			$('#testimonials-form-modal').find('.form-check-input').removeClass('is-invalid');
			var errors = false;
			if ($('#testimonial-name').val() == '') {
				errors = true;
				$('#testimonial-name').addClass('is-invalid');
			}
			if ($('#testimonial-email').val() == '') {
				errors = true;
				$('#testimonial-email').addClass('is-invalid');
			}
			if ($('#testimonial-city').val() == '') {
				errors = true;
				$('#testimonial-city').addClass('is-invalid');
			}
			if ($('#testimonial-message').val() == '') {
				errors = true;
				$('#testimonial-message').addClass('is-invalid');
			}
			if (!$('#testimonial-terms-and-conditions').is(':checked')) {
				errors = true;
				$('#testimonial-terms-and-conditions').addClass('is-invalid');
			}
			if (errors) {
				return;
			}

            //Loading...
            _this.isLoading = true;
			$(element).append('<i class="fa fa-spinner fa-spin" style="margin-right: 20px"></i>');

            var values = '_token=' + $("meta[name='csrf-token']").attr("content");
			values += '&name=' + $('#testimonial-name').val();
			values += '&email=' + $('#testimonial-email').val();
			values += '&city=' + $('#testimonial-city').val();
			values += '&message=' + $('#testimonial-message').val();
			values += '&g-recaptcha-response=' + grecaptcha.getResponse();
            $.ajax({
                type: "POST",
                url: `${baseURL}/testimonials/create`,
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').remove();
					grecaptcha.reset();

                    if (response.status == 0) {
						var errorsHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#testimonial-"+errorKey).addClass('is-invalid');
                            }
                        }

						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: response.message
						});
                        return false;
                    }

                    if (response.status == 1) {
						$('#testimonials-form-modal').find('.form-control').val('');

						const testimonailsFormModal = bootstrap.Modal.getInstance(document.getElementById('testimonials-form-modal'));
						if (testimonailsFormModal) {
							testimonailsFormModal.hide();
						}

						Swal.fire({
							icon: 'success',
							title: 'Success...',
							text: response.message
						});
                        return false;
                    }

					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
                    $(element).find('i').remove();
                }
            });
        }

    };

    testimonials.init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/testimonials.js